import { createContext } from 'react';
import { action, decorate } from 'mobx';
import { UserAgent, API_ROOT } from 'agents';

class UserStore {
    decorator(user: any) {
        user.avatar =
            API_ROOT +
            '/profile/images/' +
            user.id +
            '?web_default=1&disablecache=' +
            new Date().getTime();
        user.country = user.location?.country_code ?? 'UNKNOWN';
        return user;
    }

    update(data: any) {
        return UserAgent.update(data);
    }

    updateAvatar(avatar: any) {
        return UserAgent.uploadAvatar(avatar);
    }

    available(email: string) {
        return UserAgent.available(email);
    }

    removeAvatar() {
        return UserAgent.removeAvatar();
    }
}

decorate(UserStore, {
    decorator: action,
});

export const userStore = new UserStore();
export default createContext(userStore);
